import {
    getKYCSettings,
    addKYCSetting,
    updateKYCSetting,
    fetchKYCSettingById,
    deleteKYCSettingById
  } from "../../services/KYCSettingService";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const KYC_SETTING_LIST_INITIATED = "KYC_SETTING_LIST_INITIATED";
  export const KYC_SETTING_INITIATED = "KYC_SETTING_INITIATED";
  export const KYC_SETTING_LIST_LOADED = "KYC_SETTING_LIST_LOADED";
  export const KYC_SETTING_LOADED = "KYC_SETTING_LOADED";
  export const KYC_SETTING_FAILED = "KYC_SETTING_FAILED";
  
  export const loadKYCSettings = (getData) => {
    return (dispatch) => {
      dispatch({ type: KYC_SETTING_LIST_INITIATED });
      getKYCSettings(getData)
        .then((response) => {
          dispatch({ type: KYC_SETTING_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: KYC_SETTING_FAILED, payload: error.message });
        });
    };
  };

  export const getKYCSettingById = (id) => {
    return (dispatch) => {
      dispatch({ type: KYC_SETTING_INITIATED });
      return fetchKYCSettingById(id)
        .then((response) => {
          dispatch({ type: KYC_SETTING_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: KYC_SETTING_FAILED, payload: formatError(error) });
        });
    };
  };

  export const removeKYCSettingById = (id) => {
    return (dispatch) => {
      dispatch({ type: KYC_SETTING_INITIATED });
      return deleteKYCSettingById(id)
        .then((response) => {
          dispatch(loadKYCSettings()); // Refresh list after save
          formatSuccess('KYC Settings', response)
        })
        .catch((error) => {
          dispatch({ type: KYC_SETTING_FAILED, payload: formatError(error) });
        });
    };
  };

  
  
  export const saveKYCSettingAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: KYC_SETTING_INITIATED });
      const apiCall = isEdit ? updateKYCSetting(id, data) : addKYCSetting(data);
  
      return apiCall
        .then((response) => {
          dispatch(loadKYCSettings()); // Refresh list after save
          formatSuccess('KYC Settings', response.data)
          if(!isEdit){
            setTimeout(()=>{
              navigate('/kyc-settings');
            },1000)
          }
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: KYC_SETTING_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: KYC_SETTING_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };